import React from "react";

import SlBet from "../../SlBet";
import Portrait from "./Portrait";

import nary from "@/modules/nary";
import Nnary from "@/modules/Nnary";

import { isLandscape, isPortrait } from "@/modules/commonMobile";
import { IGameTableType } from "@/types/GlobalTypes";

import "./index.scss";
import { getBlueValue, getDiceSum, getRedValue, getWinDices, isBlueEven, isBlueHigh, isBlueLow, isBlueOdd, isBlueWin, isRedEven, isRedHigh, isRedLow, isRedOdd, isRedWin, isTie } from "@/modules/games/DuelDice";

export default class M39 extends React.PureComponent<IGameTableType> {
	private readonly SGroups = [
		["s6", "28"], 
		["s5", "14.5"], 
		["s4", "9.5"], 
		["s3", "7.5"], 
		["s2", "5.85"], 
		["s1", "4.8"], 
		["s2", "5.85"], 
		["s3", "7.5"], 
		["s4", "9.5"], 
		["s5", "14.5"], 
		["s6", "28"]
	];

	private readonly bottomBet = [
		["Odd/Even", "Odd/Odd", "Even/Odd", "Even/Even"],
		["Low/High", "Low/Low", "High/Low", "High/High"]
	];

	private readonly bottomBet2Lines = [
		["Odd/\nEven", "Odd/\nOdd", "Even/\nOdd", "Even/\nEven"],
		["Low/\nHigh", "Low/\nLow", "High/\nLow", "High/\nHigh"]
	]

	private readonly n50Bets = [
		["Odd", "n50"],
		["Even", "n50"],
		["Low", "n50"],
		["High", "n50"],
	];

	private get useCapitalLetters() {
		const {
			mobile, maximised
		} = this.props;

		return (mobile && isLandscape()) || !maximised;
	}

	private get commonBetProps() {
		const {
			pcode, chipBase, mobile, bets, insertBet, completeTable, langdata
		} = this.props;

		return ({
			pcode, chipBase, mobile, bets, insertBet, completeTable,
			langStr: langdata.language_code,
		});
	}

	/**
	 * Red odd/even/low/high
	 */
	private get topLeftFragment() {
		const { win, langdata } = this.props;

		const [odd, even] = [
			isRedOdd(win),
			isRedEven(win)
		];

		const [low, high] = [
			isRedLow(win),
			isRedHigh(win)
		];

		return (
			<div className="left">
				{
					this.n50Bets.map(item => {
						let label = langdata[`txt_m39_${item[0].toLowerCase()}`]

						if (this.useCapitalLetters) {
							label = label.toUpperCase()
						}

						const isWin = (
							(item[0] === "Odd" && odd) ||
							(item[0] === "Even" && even) ||

							(item[0] === "Low" && low) ||
							(item[0] === "High" && high)
						);

						return (
							<SlBet
								{...this.commonBetProps}
								key={"topleft_" + item}
								classes="sl-bet red"

								bet={item[0] + " Red"}
								group={item[1]}

								winStatement={isWin}

								betLabel={label}
								betType="1:0.98"
							/>
						)
					})
				}
			</div>
		);
	}

	/**
	 * Tie value
	 */
	private get topCentreFragment() {
		const { win } = this.props;

		const tie = isTie(win);
		const redValue = getRedValue(win);
		
		return (
			<div className="middle">
				{
					nary(6).map(num => {
						const isWin = tie && num === redValue;

						return (
							<SlBet
								{...this.commonBetProps}
								key={"topmid_" + num}
								classes="sl-bet green"

								bet={num + ""}
								group="tie_ind"

								winStatement={isWin}

								betLabel={num + ""}
								betType="1:30"
							/>
						);
					})
				}
			</div>
		);
	}

	/**
	 * Blue odd/even/low/high
	 */
	private get topRightFragment() {
		const { win, langdata } = this.props;

		const [odd, even] = [
			isBlueOdd(win),
			isBlueEven(win)
		];

		const [low, high] = [
			isBlueLow(win),
			isBlueHigh(win)
		];

		return (
			<div className="right">
				{
					this.n50Bets.map(item => {
						let label = langdata[`txt_m39_${item[0].toLowerCase()}`]

						if (this.useCapitalLetters) {
							label = label.toUpperCase()
						}

						const isWin = (
							(item[0] === "Odd" && odd) ||
							(item[0] === "Even" && even) ||

							(item[0] === "Low" && low) ||
							(item[0] === "High" && high)
						);

						return (
							<SlBet
								{...this.commonBetProps}
								key={"topright_" + item}
								classes="sl-bet blue"

								bet={item[0] + " Blue"}
								group={item[1]}

								winStatement={isWin}

								betLabel={label}
								betType="1:0.98"
							/>
						);
					})
				}
			</div>
		);
	}

	/**
	 * Red 1-6 on the left
	 */
	private get middleLeftFragment() {
		const { win } = this.props;
		const redValue = getRedValue(win);

		return (
			<div className="left">
				{
					nary(6).map(num =>
						<SlBet
							{...this.commonBetProps}
							key={"midleft_" + num}
							classes="sl-bet red"

							bet={num + " Red"}
							group="d1"

							winStatement={num === redValue}

							betLabel={num + ""}
							betType="1:4.9"
						/>
					)
				}
			</div>
		);
	}

	/**
	 * Last period winner
	 */
	private get middleCentreFragment() {
		const {
			commonBetProps,
			useCapitalLetters
		} = this;

		const { win, langdata } = this.props;

		const tie = isTie(win);

		const [redWin, blueWin] = [
			isRedWin(win),
			isBlueWin(win)
		];

		const label = [
			langdata['txt_m39_red'],
			langdata['txt_m39_tie'],
			langdata['txt_m39_blue'],
		]

		return (
			<div className="middle">
				<SlBet
					{...commonBetProps}
					classes="sl-bet red"

					bet="Red"
					group="n50"

					winStatement={redWin}

					betLabel={useCapitalLetters ? label[0].toUpperCase() : label[0]}
					betType="1:1"
				/>

				<SlBet
					{...commonBetProps}
					classes="sl-bet green"

					bet="Tie"
					group="tie_all"

					winStatement={tie}

					betLabel={useCapitalLetters ? label[1].toUpperCase() : label[1]}
					betType="1:4.5"
				/>

				<SlBet
					{...commonBetProps}
					classes="sl-bet blue"

					bet="Blue"
					group="n50"

					winStatement={blueWin}

					betLabel={useCapitalLetters ? label[2].toUpperCase() : label[2]}
					betType="1:1"
				/>
			</div>
		);
	}

	/**
	 * Blue 1-6 on the right
	 */
	private get middleRightFragment() {
		const { win } = this.props;
		const blueValue = getBlueValue(win);

		return (
			<div className="right">
				{
					nary(6).map(num =>
						<SlBet
							{...this.commonBetProps}
							key={"midright_" + num}
							classes="sl-bet blue"

							bet={num + " Blue"}
							group="d1"

							winStatement={num === blueValue}

							betLabel={num + ""}
							betType="1:4.9"
						/>
					)
				}
			</div>
		);
	}

	/**
	 * Sum of dice values
	 * Orange area
	 */
	private get numberRowFragment() {
		const { win } = this.props;
		const diceSum = getDiceSum(win);

		return (
			<div className="number-row">
				{
					Nnary(2, 12).map(num =>
						<SlBet
							{...this.commonBetProps}
							key={"numrow_" + num}
							classes="sl-bet orange"

							bet={num + ""}
							group={this.SGroups[num - 2][0]}

							winStatement={num === diceSum}

							betLabel={num + ""}
							betType={`1:${this.SGroups[num - 2][1]}`}
						/>
					)
				}
			</div>
		);
	}

	/**
	 * Odd/Even (purple area)
	 */
	private get bottomLeftFragment() {
		const {
			bottomBet,
			useCapitalLetters,
			commonBetProps
		} = this;

		const {
			langdata
		} = this.props;

		// const renderBottomBetKey = bottomBet[0]
		// const renderBottomBet = (!mobile && maximised
		// 	? bottomBet[0]
		// 	: bottomBet2Lines[0]);

		const renderBottomBet = bottomBet[0]

		// Process win string
		const { win } = this.props;
		const [redValue, blueValue] = [
			getRedValue(win),
			getBlueValue(win)
		];

		// Reference: row 1
		const [redOdd, blueOdd] = [
			redValue % 2 > 0,
			blueValue % 2 > 0
		];

		const [redEven, blueEven] = [
			redValue > 0 && !redOdd,
			blueValue > 0 && !blueOdd
		]

		const winAry = [
			redOdd && blueEven,
			redOdd && blueOdd,
			redEven && blueOdd,
			redEven && blueEven
		];

		return (
			<div className="left">
				{
					renderBottomBet.map((item, idx) => {
						let label = langdata[`txt_m39_${item}`]
						if ( useCapitalLetters ) {
							label = label.toUpperCase()
						}

						return (
							<SlBet
								{...commonBetProps}
								key={"bottomleft_" + item}
								classes="sl-bet purple"

								bet={item}
								group="pairs"

								winStatement={winAry[idx]}

								betLabel={label}
								betType="1:2.93"
							/>
						)
					})
				}
			</div>
		);
	}

	/**
	 * Any dice that wins (grey area)
	 */
	private get bottomCentreFragment() {
		const { win } = this.props;
		const winDices = getWinDices(win);

		return (
			<div className="middle">
				{
					nary(6).map(num =>
						<SlBet
							{...this.commonBetProps}
							key={"bottommid_" + num}
							classes="sl-bet grey"

							bet={num + ""}
							group="any_number"

							winStatement={winDices.includes(num)}

							betLabel={num + ""}
							betType="1:2.21"
						/>
					)
				}
			</div>
		);
	}

	/**
	 * Low/High (yellow area)
	 */
	private get bottomRightFragment() {
		const {
			bottomBet,
			useCapitalLetters,
			commonBetProps
		} = this;

		const { langdata } = this.props;

		// const renderBottomBetKey = bottomBet[1]
		// const renderBottomBet = (!mobile && maximised
		// 	? bottomBet[1]
		// 	: bottomBet2Lines[1]);

		const renderBottomBet = bottomBet[1]

		// Process win string
		const { win } = this.props;
		const [redValue, blueValue] = [
			getRedValue(win),
			getBlueValue(win)
		];

		// Reference: row 1
		const [redLow, blueLow] = [
			redValue <= 3,
			blueValue <= 3
		];

		const [redHigh, blueHigh] = [
			redValue > 3,
			blueValue > 3
		]

		const winAry = [
			redLow && blueHigh,
			redLow && blueLow,
			redHigh && blueLow,
			redHigh && blueHigh
		];

		return (
			<div className="right">
				{
					renderBottomBet.map((item, idx) => {
						let label = langdata[`txt_m39_${item}`]
						if ( useCapitalLetters ) {
							label = label.toUpperCase()
						}

						return (
							<SlBet
								{...commonBetProps}
								key={"bottomright_" + item}
								classes="sl-bet yellow"

								bet={item}
								group="pairs"

								winStatement={winAry[idx]}

								betLabel={label}
								betType="1:2.93"
							/>
						);
					})
				}
			</div>
		);
	}

	render() {
		if (isPortrait())
			return <Portrait {...this.props} />;

		const {
			completeTable,
			maximised
		} = this.props;

		const isLessTable = !completeTable && maximised;

		const classes = [
			"sl-table",
			"m39",
			isLessTable ? "less-table" : ""
		].join(" ");

		return (
			<div className={classes}>
				<div className="top">
					{this.topLeftFragment}
					{this.topCentreFragment}
					{this.topRightFragment}
				</div>

				<div className="middle">
					{this.middleLeftFragment}
					{this.middleCentreFragment}
					{this.middleRightFragment}
				</div>

				{this.numberRowFragment}

				{
					!isLessTable
						? (
							<div className="bottom">
								{this.bottomLeftFragment}
								{this.bottomCentreFragment}
								{this.bottomRightFragment}
							</div>
						) : null
				}
			</div>
		);
	}
}